import React, { FC } from 'react';
import clsx from 'clsx';

import styles from './IconButton.module.scss';

export interface IconButtonProps {
  icon?: string;
  type?: 'primary' | 'secondary' | 'destroy';
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
  iconClassName?: string;
  id?: string;
  onBlur?: () => void;
  tabIndex?: number;
  testId?: string;
  badgeTestId?: string;
  title?: string;
  badge?: number;
  badgeMax?: number;
  isErrorBadge?: boolean;
  children?: React.ReactNode;
}

export const IconButton: FC<IconButtonProps> = React.forwardRef<
  HTMLAnchorElement,
  IconButtonProps
>(function IconButton(props, ref) {
  const {
    type = 'primary',
    badge,
    badgeMax = 99,
    isErrorBadge,
    badgeTestId,
    ...rest
  } = props;
  const showBadge = typeof badge === 'number' && badge != 0;
  const badgeText = badge && badge > badgeMax ? `${badgeMax}+` : badge;

  return (
    <a
      ref={ref}
      data-disabled={props.disabled}
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
        e.stopPropagation();
        props.onClick?.(e);
      }}
      className={clsx(styles.iconButton, styles[type], props.className)}
      id={props.id}
      onBlur={props.onBlur}
      tabIndex={props.tabIndex}
      data-test-id={props.testId}
      title={props.title}
    >
      {props.children ? (
        <div className={clsx(styles.image, props.iconClassName)}>
          {props.children}
        </div>
      ) : (
        <img
          className={clsx(styles.image, props.iconClassName)}
          src={props.icon}
          alt=""
        />
      )}

      {showBadge && (
        <span
          data-test-id={badgeTestId}
          className={clsx(styles.badge, isErrorBadge ? styles.badgeError : '')}
        >
          {isErrorBadge ? '!' : badgeText}
        </span>
      )}
    </a>
  );
});
